import React from 'react';
import { motion } from 'framer-motion';
export function MissionStrip() {
  return <section className="bg-foodMaroon text-foodCream py-16 border-y-4 border-foodMaroon" data-id="element-117" data-mp="3evxaf6d2d3oy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118" data-mp="39wkpir5r66p0">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-119" data-mp="39wufwfupmfv8">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-120" data-mp="34yapa2568fwj">
            <h2 className="text-4xl md:text-5xl font-extrabold uppercase leading-tight mb-6" data-id="element-121" data-mp="3sv6pu3tg3trv">
              Food is the <span className="text-foodGold" data-id="element-122" data-mp="3nwvgrvaz5nap">foundation</span> of a
              strong community.
            </h2>
            <p className="text-lg text-foodCream/80 font-medium" data-id="element-123" data-mp="p6n04swefroa">
              We provide the space, resources, and platform for local culinary
              talent to thrive, while giving our neighborhood a vibrant place to
              gather and connect.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-124" data-mp="2fr32ze097igu">
            <div className="bg-foodOrange border-2 border-foodCream p-6 text-center shadow-[4px_4px_0px_0px_#F5EFE0] rotate-[-2deg]" data-id="element-125" data-mp="1rzxmcwmhom5h">
              <span className="block text-5xl font-display font-extrabold mb-1" data-id="element-126" data-mp="1j0u0xlzununt">
                2
              </span>
              <span className="block text-sm font-bold uppercase" data-id="element-127" data-mp="1nyvjm5td5ryr">
                Years Strong
              </span>
            </div>
            <div className="bg-foodTeal border-2 border-foodCream p-6 text-center shadow-[4px_4px_0px_0px_#F5EFE0] rotate-[1deg] translate-y-4" data-id="element-128" data-mp="3df4pdtcj8mt2">
              <span className="block text-4xl font-display font-extrabold mb-1" data-id="element-129" data-mp="3fyrnvjsonhch">
                40+
              </span>
              <span className="block text-sm font-bold uppercase" data-id="element-130" data-mp="3bx6c61rvx93v">
                Local Vendors
              </span>
            </div>
            <div className="bg-foodGold text-foodMaroon border-2 border-foodCream p-6 text-center shadow-[4px_4px_0px_0px_#F5EFE0] rotate-[-1deg]" data-id="element-131" data-mp="36yldw7w70zi2">
              <span className="block text-4xl font-display font-extrabold mb-1" data-id="element-132" data-mp="3i4io9d34n1h">
                2k
              </span>
              <span className="block text-sm font-bold uppercase" data-id="element-133" data-mp="3uoywz8wsvo0i">
                Neighbors Served
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}